import { createAuthClient } from "better-auth/react";

const getAuthBaseUrl = () => {
  const configuredUrl =
    process.env.NEXT_PUBLIC_NEXTAUTH_URL || process.env.NEXT_PUBLIC_APP_URL;

  if (configuredUrl) return configuredUrl;

  if (typeof window !== "undefined") return window.location.origin;

  return "http://localhost:3000";
};

export const authClient = createAuthClient({
  baseURL: getAuthBaseUrl(),
});

export const { useSession, signIn, signOut } = authClient;
